import { persistentAtom } from '@nanostores/persistent';

const LOCAL_STORAGE_KEY = 'hb_distinct_id';

export const distinctId = persistentAtom<string>(LOCAL_STORAGE_KEY, '');

export function setDistinctId(newDistinctId: string) {
  if (!newDistinctId.trim()) {
    throw new Error('Distinct ID cannot be empty');
  }
  distinctId.set(newDistinctId);
}

export function getDistinctId(): string {
  return distinctId.get() || '';
}

export function clearDistinctId() {
  distinctId.set('');
}
